import { ForwardedRef, forwardRef, useState } from "react"
import cn from "classnames"
import { FloatingLabel } from "flowbite-react"
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"
import usePreRender from "hooks/usePreRender"

interface ITextField {
  label: string
  type?: "text" | "email" | "password" | "number"
  value?: string | number
  onChange?: () => void
  placeholder?: string
  className?: string
  helperText?: string
  disabled?: boolean
  [k: string]: any
}

const TextField = forwardRef(
  (
    { className, label, onChange, value, type = "text", helperText, disabled, placeholder, ...rest }: ITextField,
    ref: ForwardedRef<HTMLInputElement>,
  ) => {
    const { _color } = usePreRender()
    const [is_password_visible, set_is_password_visible] = useState<boolean>(false)
    const icon_password_styles = "absolute top-4 right-4 text-gray-600 text-lg z-40 cursor-pointer"

    function togglePasswordVisibility() {
      set_is_password_visible((prevState: boolean) => !prevState)
    }

    if (type === "password")
      return (
        <div className="relative w-full h-14">
          <FloatingLabel
            {...rest}
            ref={ref}
            type={is_password_visible ? "text" : "password"}
            label={label}
            onChange={onChange}
            value={value}
            variant="outlined"
            disabled={Boolean(disabled)}
            className={cn(`focus:border_${_color} peer-focus:text_${_color}`, className, {
              "bg-gray-100 cursor-not-allowed": Boolean(disabled),
            })}
            helperText={helperText}
          />
          <button type="button" onClick={togglePasswordVisibility} disabled={Boolean(disabled)}>
            {is_password_visible ? (
              <AiOutlineEye className={icon_password_styles} />
            ) : (
              <AiOutlineEyeInvisible className={icon_password_styles} />
            )}
          </button>
        </div>
      )

    return (
      <div className="w-full h-14">
        <FloatingLabel
          {...rest}
          ref={ref}
          type={type}
          label={label}
          onChange={onChange}
          placeholder={label ? " " : placeholder}
          value={value}
          variant="outlined"
          disabled={Boolean(disabled)}
          className={cn("z-0 first-letter:capitalize", `focus:border_${_color} peer-focus:text_${_color}`, className, {
            "cursor-not-allowed bg-gray-100": Boolean(disabled),
          })}
          helperText={helperText}
        />
      </div>
    )
  },
)

TextField.displayName = "TextField"

export default TextField
